<template>
	<div>
		<el-tabs type="card" v-model="tagConfig">
			<el-tab-pane label="Config" name="tab-conclusao">
				<span slot="label">
					<i class="fa fa-wpforms"></i> Conclusão Técnica
				</span>
				<ed-alert 
					type="warning" 
					description="Aqui você pode cadastrar todas as conclusões técnicas. Essas conclusões podem ser vinculados no cadastro do LTCAT."
				/>
				<Conclusao/>
			</el-tab-pane>
			<el-tab-pane label="Config" name="tab-modelo">
				<span slot="label">
					<i class="fa fa-files-o"></i> Ocultar Items no Documento
				</span>
				<ed-alert 
					type="warning" 
					description="Aqui você pode ocultar ou exibir os items no modelo do LTCAT criado."
				/>
				<Modelo/>
			</el-tab-pane>
			<!-- <el-tab-pane label="Config" name="tab-anexo">
				<span slot="label">
					<i class="fa fa-upload"></i> Anexos
				</span>
				<ed-alert 
					type="warning" 
					description="Aqui você pode fazer upload de imagens que poderão ser vinculados no documento final do LTCAT (word). Para vincular um anexo você precisa acessar o menú LTCAT > Modelos e então inserir o link do anexo no conteúdo do documento."
				/>
				<Anexo/>
			</el-tab-pane> -->
		</el-tabs>
	</div>
</template>

<script>

	import EdAlert from 'common/alert'
	import Conclusao from './conclusao-tecnica/index'
	import Modelo from './modelo/index'

  	export default {
  		name:"empresa",
  		components: {EdAlert,Conclusao,Modelo},
		mixins:[],
		props:{
		},
		watch:{
		},
  		data () {
		   	return {
				tagConfig:'tab-conclusao',

			}
		},

		created(){
		},

		mounted: function() {
		},
		methods: {

		}
  	}
</script>


// WEBPACK FOOTER //
// index.vue?cf9a5a68